<template>
  <div class="tablet:flex tablet:items-center">
    <div
      class="mb-4 w-full tablet:mb-0 tablet:w-6/12 tablet:pr-2.5 desktop:pr-8"
    >
      <LightboxAlbum
        :album-name="itemData.name"
        :album-image-url="thumbnailUrl"
      />
    </div>
    <div class="w-full tablet:w-6/12 tablet:pl-2.5 desktop:pl-8">
      <h3 class="mb-4 font-bold tablet:text-lg desktop:text-xl">
        {{ itemData.name }}
      </h3>
      <p
        class="mb-5 whitespace-pre-line text-sm text-gray-600 tablet:text-base"
      >
        {{ itemData.description }}
      </p>
      <TheButton
        :to="`/${locale}/marketplace/products/${itemData.alias}`"
        :title="t('learn-more')"
        class="w-full tablet:w-[180px]"
      >
        <span class="text-sm">{{ t('learn-more') }}</span>
      </TheButton>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { IProductInfoLearnMoreItem } from '@/assets/types/api/Products';

  interface IProps {
    itemData: IProductInfoLearnMoreItem;
  }

  const props = withDefaults(defineProps<IProps>(), {
    itemData: () => ({
      briefTabName: '',
      name: '',
      description: '',
      webThumbnail: '',
      tabletThumbnail: '',
      mobileThumbnail: '',
      alias: '',
    }),
  });

  const { t, locale } = useI18n({ useScope: 'local' });
  const { isMobile, isTablet } = useScreen();

  const thumbnailUrl = computed((): string => {
    const { webThumbnail, tabletThumbnail, mobileThumbnail } = props.itemData;
    if (isMobile.value) return mobileThumbnail;
    if (isTablet.value) return tabletThumbnail;
    return webThumbnail;
  });
</script>

<i18n lang="json">
{
  "en-int": {
    "learn-more": "Learn more"
  },
  "en-jp": {
    "learn-more": "Learn more"
  },
  "en-tw": {
    "learn-more": "Learn more"
  },
  "en-kr": {
    "learn-more": "Learn more"
  },
  "en-americas": {
    "learn-more": "Learn more"
  },
  "en-asia-pacific": {
    "learn-more": "Learn more"
  },
  "en-emea": {
    "learn-more": "Learn more"
  },
  "ja-jp": {
    "learn-more": "詳細を見る"
  },
  "zh-cn": {
    "learn-more": "了解更多"
  },
  "zh-tw": {
    "learn-more": "瞭解更多"
  }
}
</i18n>
